import { ErrorHandler, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { ApmModule } from "@elastic/apm-rum-angular";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AutocompleteLibModule } from "angular-ng-autocomplete";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { RecaptchaModule } from "ng-recaptcha";
import { NgxMaskModule, IConfig } from "ngx-mask";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { TokenInterceptor } from "./share/interceptors/token.interceptor";
import { AuditoriaInterceptor } from "./share/interceptors/auditoria.interceptor";
import { APMErrorHandler } from "./APMErrorHandler";
import { CoreModule } from "./core/core.module";
import { RecaptchaLoaderService } from "ng-recaptcha";


export const options: Partial<IConfig> | (() => Partial<IConfig>) = {};

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AutocompleteLibModule,
    BsDatepickerModule.forRoot(),
    BrowserAnimationsModule,
    FormsModule,
    RecaptchaModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot(options),
    CoreModule,
    HttpClientModule,
    NgbModule,
    ApmModule
  ],
  providers: [
    {
      provide: RecaptchaLoaderService,
      useValue: {
        onbeforeunload() {
          const recaptchaEnterpriseUrl = new URL(
            "https://www.google.com/recaptcha/enterprise.js"
          );
          return { url: recaptchaEnterpriseUrl };
        },
        onload(recaptcha) {
          return recaptcha.enterprise;
        },
      },
    },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuditoriaInterceptor, multi: true },
    {
      provide: ErrorHandler,
      useClass: APMErrorHandler,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
